module.exports = __webpack_public_path__ + "static/enterprise-1-m-1f19d6ca787853a31c50aaf8c6f36b4d.png";